import request from "@/services/simpleRequest";
import { IOrderDetail, IPostOrderPayParams, IPostOrderPayRes } from "@/types/payment";
import { AxiosRequestConfig } from "axios";

// 获取订单信息
export function getOrderDetail(orderId: string): Promise<IOrderDetail> {
  const params = {
    orderId,
  };
  return request.get(`/api/open/order/detail`, {
    params,
  });
}

// 查询支付订单
// export function getPayResult(orderId: string): Promise<IPayResult> {
//   const params = {
//     orderId,
//   };
//   return request.get(`/api/auth/payment/query`, {
//     params,
//   });
// }

// 订单支付
export function postOrderPay(
  params: IPostOrderPayParams,
  config?: AxiosRequestConfig<unknown>
): Promise<IPostOrderPayRes> {
  return request.post("/api/open/payment/pay", params, {
    ...config,
  });
}

// 获取微信openid
export function getWxOpenId(sessionId:string, code: string): Promise<{ openid: string }> {
  const appId = import.meta.env.VITE_WX_PAYMENT_APP_ID;

  return request.get(`/api/auth/weixin/token/info/code/${appId}`, {
    params: { code },
    headers: {
      'x-session-id': sessionId
    }
  });
}
